/**
 * @generated SignedSource<<0bcf55958e2b6681ac18224a72560a7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecentActivityRowFragment$data = {
  readonly ofLastTenProps: number;
  readonly " $fragmentType": "RecentActivityRowFragment";
};
export type RecentActivityRowFragment$key = {
  readonly " $data"?: RecentActivityRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecentActivityRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecentActivityRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ofLastTenProps",
      "storageKey": null
    }
  ],
  "type": "DelegateMetrics",
  "abstractKey": null
};

(node as any).hash = "d3b231b46372fa8c9718626e5b3d84bf";

export default node;
